export enum TAB_ITEMS_KEYS {
  'Profile' = 'Profile',
  'Users' = 'Users',
  'Brands' = 'Brands',
  'PaymentMethods' = 'Payment Methods',
  'Billing' = 'Billing',
  'Notifications' = 'Notifications',
}

export type Tab = {
  title: TAB_ITEMS_KEYS;
  url: string;
  icon: JSX.Element;
  hidden?: boolean;
};
